import iziToast, { IziToastSettings } from 'izitoast';
import { APP_TRANSLATE } from 'src/app/app-translate';
import Swal, { SweetAlertOptions } from 'sweetalert2';

const defaultSettings: IziToastSettings = {
  position: 'topRight',
  timeout: 5000,
};

const translate = (key: string, params?: Record<string, any>): string => {
  const res = APP_TRANSLATE?.instant?.(key, params);
  return typeof res === 'string' ? res : key;
};

export function alertSuccess(settings: IziToastSettings = {}) {
  return iziToast.success({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('SUCCESS'),
    message: ``,
    ...settings,
  });
}
export function alertWarning(settings: IziToastSettings = {}) {
  return iziToast.warning({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('ALERT'),
    message: ``,
    ...settings,
  });
}
export function alertInfo(settings: IziToastSettings = {}) {
  return iziToast.info({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('DATA'),
    message: ``,
    ...settings,
  });
}
export function alertDanger(settings: IziToastSettings = {}) {
  return iziToast.error({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('ERROR'),
    message: ``,
    ...settings,
  });
}

const defaultOptions: SweetAlertOptions = {
  icon: 'warning',
  showCancelButton: true,
  showConfirmButton: true,
  cancelButtonText: translate('CANCEL'),
  confirmButtonText: translate('CONFIRM'),
  reverseButtons: true,
  focusCancel: true,
  confirmButtonColor: 'var(--bs-primary)',
};
export function alertConfirm(options: SweetAlertOptions = {}) {
  return Swal.fire({
    ...defaultOptions,
    title: translate('CONFIRMATION'),
    // html: `คุณต้องการดำเนินการต่อ?`,

    ...Object.assign(
      {},
      {
        ...options,
        html: options.html || options.text || translate('DO_YOU_WANT_TO_CONTINUE'),
      }
    ),
  });
}
export function alertConfirmDanger(options: SweetAlertOptions = {}) {
  return Swal.fire({
    ...defaultOptions,
    title: options.title ?? translate('CONFIRMATION'),
    // html: `คุณต้องการดำเนินการต่อ?`,
    confirmButtonColor: 'var(--bs-danger)',
    iconColor: 'var(--bs-danger)',
    ...Object.assign(
      {},
      {
        ...options,
        html: options.html || options.text || translate('DO_YOU_WANT_TO_CONTINUE'),
      }
    ),
  });
}

export enum alertText {
  formInvalid = 'PLEASE_FILL_IN_ALL_REQUIRED_FILEDS',
  saveSuccess = 'ALERT_SAVE_SUCCESS',
  loginSuccess = 'ALERT_LOGIN_SUCCESS',
  confirmDelete = 'DO_YOU_WANT_TO_DELETE_DATA',
  deleteSuccess = 'ALERT_DELETE_SUCCESS',
}

// export enum alertText {
//   formInvalid = 'กรุณากรอกข้อมูลให้ครบ',
//   saveSuccess = 'บันทึกข้อมูลสำเร็จ',
//   loginSuccess = 'เข้าสู่ระบบสำเร็จ',
//   confirmDelete = 'คุณต้องการลบข้อมูล?',
//   deleteSuccess = 'ลบข้อมูลสำเร็จ',
// }

export function getAlertText(key: alertText): string {
  return translate(key);
}

export function confirmDelete(text: string): string {
  return translate('CONFIRM_DELETE_ITEM', { text });
}